import React from "react";
import { Link } from "react-router";

const Footer = () => {
  return (
    <footer>
      <hr />
      <div className="flex items-center justify-center py-5">
        <p className="text-[#1467b0] text-sm">
          <Link to="privacy-policy">Spade, LLC</Link>{" "}
          <span className="text-black dark:text-white ">
            &copy; 2024 - {new Date().getFullYear()}
          </span>{" "}
        </p>
      </div>
    </footer>
  );
};

export default Footer;
